import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';
import { CanceledFilter } from 'src/app/shared/models/canceledFilter.model';

@Injectable({ providedIn: 'root' })
export class CanceledService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: CanceledFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.startDate', filter.startDate || '')
            .set('filter.entity.endDate', filter.endDate || '')
            .set('filter.entity.searchLimit', filter.searchLimit.toString())
            .set('filter.entity.clientId', filter.clientId)
            .set('filter.entity.id', filter.id)
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT);;

        return this.dataService.get<Result<any>>("request/canceled", params);
    }
}
